module.exports = __webpack_public_path__ + "img/img4.9261aace.png";